import React, { useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import {
  showTimeByDateType,
  newMathFormat,
  getCountryNameByCountryCode,
} from '@/pages/intelligence/utils/commonUtils';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import useSinglePieCharts from '@/pages/intelligence/components/Chart/hooks/useSinglePieCharts';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import moment from 'moment';
import { getIfPercentage } from '@/pages/intelligence/utils/common';

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    dateType,
    lineData = [], // 折线 数据
    isNodata,
    imageType,
    metric,
    titleNow,
    chartLoading,
    setChartLoading,
    topChartsType,
    renderType,
    barOrPieList,
    gameName,
  } = props;
  const cardRef = useRef(null);
  // console.log('Visualis334', props);

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      arr.push({
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value || null,
      });
    }
    return arr;
  };

  const getMetricsList = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const objTemp = {
        cover: list[n].cover,
        id: list[n].game_id,
        name: list[n].game_name,
        history: getRpdTypeData(list[n].date_info || []),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    if (!Array.isArray(lineData) || lineData?.length < 1) return {};
    const temp = {
      source: getMetricsList(lineData || []),
    };
    return temp;
  }, [lineData, metric]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: 'source',
    // topChartsType: 'pcconsole-stats-line',
    imageType,
    titleNow: 'PCU',
    chartType,
    setChartLoading,
    dateType,
    ifNeedMoveZero: false,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
